import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../environments/environment";
import { HelperService } from "./helper.service";

export type FirmwareInstructionMode = "update" | "recover" | "dante" | "faderport-1.35" | "faderport-1.38" | "option-card-dante";

/** Product title resolved by admin list/get/create/update responses. */
export interface FirmwareInstructionProductRef {
  id: number;
  title: string | null;
}

export interface FirmwareInstructionDoc {
  id: string;
  productIds: number[];
  mode: FirmwareInstructionMode;
  mainContent: string;
  title: string;
  translations: Record<string, string>;
  /** Present on admin read responses — titles resolved from MySQL in one batch. */
  products?: FirmwareInstructionProductRef[];
  createdAt?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface FirmwareInstructionPayload {
  productIds: number[];
  mode: FirmwareInstructionMode;
  mainContent: string;
  title: string;
  translations: Record<string, string>;
}

@Injectable({
  providedIn: "root",
})
export class FirmwareInstructionsService {
  private baseUrl = environment.paeApiUrl + "admin/firmware-instructions";

  constructor(
    private http: HttpClient,
    private _helpers: HelperService
  ) {}

  list() {
    return this.http.get(this.baseUrl, this._helpers.getPaeApiOptions(this._helpers.token)).pipe(map((data: any) => (data?.docs as FirmwareInstructionDoc[]) || []));
  }

  get(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`, this._helpers.getPaeApiOptions(this._helpers.token)).pipe(map((data: any) => data?.doc as FirmwareInstructionDoc));
  }

  create(body: FirmwareInstructionPayload) {
    return this.http.post(this.baseUrl, body, this._helpers.getPaeApiOptions(this._helpers.token)).pipe(map((data: any) => data?.doc as FirmwareInstructionDoc));
  }

  update(id: string, body: Partial<FirmwareInstructionPayload>) {
    return this.http.put(`${this.baseUrl}/${id}`, body, this._helpers.getPaeApiOptions(this._helpers.token)).pipe(map((data: any) => data?.doc as FirmwareInstructionDoc));
  }

  delete(id: string) {
    return this.http.delete(`${this.baseUrl}/${id}`, this._helpers.getPaeApiOptions(this._helpers.token));
  }
}
